
import { useEffect, useState } from "react";
import DateTimePicker from "../components/DateTimePicker.jsx";

const API = import.meta.env.VITE_API_BASE_URL;

export default function AdminEvents() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");
  const [form, setForm] = useState({ id:"", title:"", description:"", starts_at:"" });

  async function load() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/v1/admin/events?limit=50`, { credentials:"include" });
      const j = await r.json();
      setItems(j.items || []);
    } catch (e) {
      console.error(e);
      setMsg("Load failed");
    }
    setLoading(false);
  }

  useEffect(()=>{ load(); }, []);

  function edit(e) {
    setForm({
      id: e.id,
      title: e.title || "",
      description: e.description || "",
      starts_at: e.starts_at || "",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function resetForm() {
    setForm({ id:"", title:"", description:"", starts_at:"" });
  }

  async function save(e) {
    e.preventDefault();
    setMsg("Saving…");
    try {
      const isNew = !form.id;
      const url = isNew ? `${API}/v1/admin/events` : `${API}/v1/admin/events/${form.id}`;
      const method = isNew ? "POST" : "PUT";
      const r = await fetch(url, {
        method,
        credentials:"include",
        headers:{ "Content-Type": "application/json" },
        body: JSON.stringify({
          title: form.title,
          description: form.description || "",
          starts_at: form.starts_at || null,
        }),
      });
      if (!r.ok) {
        const j = await r.json().catch(()=>({}));
        setMsg(`Save failed: ${j.error || r.status}`);
        return;
      }
      setMsg("Saved.");
      resetForm();
      await load();
    } catch (err) {
      console.error(err);
      setMsg("Save failed (network).");
    }
  }

  async function removeOne(id) {
    if (!confirm("Delete this event?")) return;
    setMsg("Deleting…");
    try {
      const r = await fetch(`${API}/v1/admin/events/${id}`, {
        method:"DELETE", credentials:"include"
      });
      if (!r.ok) {
        const j = await r.json().catch(()=>({}));
        setMsg(`Delete failed: ${j.error || r.status}`);
        return;
      }
      setMsg("Deleted.");
      await load();
    } catch (e) {
      console.error(e);
      setMsg("Delete failed (network).");
    }
  }

  function downloadCsv(id) {
    // Same-origin via /api, so cookie is first-party; anchor download works.
    const a = document.createElement("a");
    a.href = `${API}/v1/admin/events/${id}/rsvps.csv`;
    a.download = `event_${id}_rsvps.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return (
    <div style={{ padding:16 }}>
      <h1>Admin • Events</h1>

      <form onSubmit={save} style={{ marginBottom: 20, padding:12, border:"1px solid #eee", borderRadius:8 }}>
        <div style={{ display:"grid", gap:10 }}>
          <label>Title
            <input value={form.title} onChange={e=>setForm(f=>({...f, title:e.target.value}))} />
          </label>
          <label>Description
            <textarea rows={3} value={form.description} onChange={e=>setForm(f=>({...f, description:e.target.value}))} />
          </label>
          <DateTimePicker
            label="Starts at (UTC)"
            value={form.starts_at}
            onChange={(iso)=>setForm(f=>({ ...f, starts_at: iso }))}
            help="Pick local; stored as UTC ISO."
          />
        </div>
        <div style={{ marginTop:10, display:"flex", gap:8 }}>
          <button type="submit">{form.id ? "Update" : "Create"}</button>
          {form.id ? <button type="button" onClick={resetForm}>Cancel edit</button> : null}
        </div>
      </form>

      <p style={{ fontSize:12, opacity:.7 }}>Status: {msg}</p>

      {loading ? <p>Loading…</p> : (
        <table cellPadding="6" style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ textAlign:"left", borderBottom:"1px solid #eee" }}>
              <th>ID</th><th>Title</th><th>Starts (UTC)</th><th>Actions</th>
            </tr>
          </thead>
        <tbody>
          {items.map(e => (
            <tr key={e.id} style={{ borderBottom:"1px solid #f1f1f1" }}>
              <td style={{ fontFamily:"monospace" }}>{e.id}</td>
              <td>{e.title}</td>
              <td>{e.starts_at || "—"}</td>
              <td style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                <button onClick={()=>edit(e)}>Edit</button>
                <button onClick={()=>downloadCsv(e.id)}>RSVPs CSV</button>
                <button onClick={()=>removeOne(e.id)} style={{ color:"#b00020" }}>Delete</button>
              </td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={4}>No events yet.</td></tr>}
        </tbody>
        </table>
      )}
    </div>
  );
}
